/** @jsx jsx */
import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import MapContainer from "../map"
import { jsx } from "theme-ui"
import { useBreakpointIndex } from '@theme-ui/match-media'
// Icons
import Facebook from "../../icons/social/facebook.svg"
import Instagram from "../../icons/social/instagram.svg"
import Twitter from "../../icons/social/twitter.svg"
import Layout from "../layout"
import IconText from "../Navigation/IconText"
import Logo from "../Navigation/Logo"
import { menuLeftItems, menuRightItems } from '../Navigation/MenuItems'

const OpenHours = [
    {day: 'Sunday', hours: 'Closed'},
    {day: 'Monday', hours: '11:00 AM - 10:00 PM'},
    {day: 'Tuesday', hours: '11:00 AM - 10:00 PM'},
    {day: 'Wednesday', hours: '11:00 AM - 10:00 PM'},
    {day: 'Thursday', hours: '11:00 AM - 10:00 PM'},
    {day: 'Friday', hours: '11:00 AM - 10:30 PM'},
    {day: 'Saturday', hours: '11:00 AM - 10:30 PM'},
]

const SingleHour = props => (
    <div sx={{
        display: 'flex',
        fontSize: 2,
        justifyContent: 'space-between',
        py: 1,
        borderBottom: '1px solid rgba(255,255,255,0.1)'
    }}>
        <div>{props.day}</div>
        <div>{props.hours}</div>
    </div>
)

const SocialIcon = props => (
    <a href={props.href} sx={{
        width: '1.5rem',
        height: '1.5rem',
        display: 'inline-block',
        mx: 2,

        svg: {
            width: '100%',
            height: '100%',
            fill: 'white',
            opacity: 0.8
        },

        'svg:hover': {
            opacity: 1
        }
    }} title="Social">{props.children}</a>
)

const FooterHeading = props => (
<span sx={{opacity: 0.6, fontSize: 1, textTransform: 'uppercase', my: 1, fontWeight: 'heading'}}>{props.children}</span>
)

const FooterNavItem = props => (
    <li><AnchorLink to={props.to} sx={{
        color: 'white',
        fontSize: 2,
        display: 'inline-block',
        my: 1,
        textDecoration: 'none',

        '&:hover': {
            opacity: 0.7
        }
    }}>{props.title}</AnchorLink></li>
)

export class MapContainerWrapper extends React.Component {
    componentDidMount() {
        
    }
    
    render() {
        return(
            <div><MapContainer /></div>
        )
    }
}

export default function Footer(props) {
    const breakpointIndex = useBreakpointIndex();
    return(
        <div sx={{
            color: 'white',
            bg: 'secondaryDarkerColor',
            mt: 9
        }} id={props.id}>
            <Layout>
                <div sx={{
                    display: 'grid', 
                    gridTemplateColumns: ['auto auto', '1fr 1fr 3fr', 'auto 12% 25% auto'],
                    gridTemplateRows: ['auto auto auto', 'auto auto', 'auto'],
                    columnGap: '2rem',
                    rowGap: '3rem',
                    py: 9
                    }}>
                    <div sx={{
                        gridColumnStart: [1, 1, 1],
                        gridColumnEnd: [4, 1, 1],
                        gridRowStart: [3, 1, 1],
                        textAlign: 'center'
                    }}>
                        <Logo />
                        <div sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 4
                        }}>
                            <SocialIcon href="#"><Facebook /></SocialIcon>
                            <SocialIcon href="#"><Twitter /></SocialIcon>
                            <SocialIcon href="#"><Instagram /></SocialIcon>
                        </div>
                    </div>
                    <div sx={{
                        gridColumnStart: [null, 2, 2],
                        gridColumnEnd: [null, 3, 2],
                    }}>
                        <FooterHeading>Navigation</FooterHeading>
                        <ul sx={{margin: 0, padding: 0, listStyle: 'none'}}>
                            {menuLeftItems.map((item, index) => (
                                <FooterNavItem to={item.to} title={item.title} key={index}></FooterNavItem>
                            ))}
                            {menuRightItems.map((item, index) => (
                                <FooterNavItem to={item.to} title={item.title} key={index}></FooterNavItem>
                            ))}
                        </ul>
                    </div>
                    <div sx={{
                        gridColumnStart: [2, 3, 3],
                        gridColumnEnd: [4, 5, 3],
                    }}>
                        <FooterHeading>Find Us</FooterHeading>
                        <IconText iconSize="big" variant="directions" text="28 Waverly PI, San Francisco, CA 94108"/>
                        <IconText iconSize="big" variant="phone" text="(123) 456 7890" />
                        {breakpointIndex === 2 ? (
                            <MapContainerWrapper />
                        ) : (null)}
                    </div>
                    <div sx={{
                        gridColumnStart: [1,2,4],
                        gridColumnEnd: [4,5, 4],
                        gridRowStart: [2,2, 1]
                    }}>
                        <FooterHeading>Open Hours</FooterHeading>
                        <div>
                            {OpenHours.map((item, index) => (
                                <SingleHour day={item.day} hours={item.hours} key={index}></SingleHour>
                            ))}
                        </div>
                    </div>
                </div>
                <div sx={{fontSize: 1, textAlign: 'center', pb: 5}}>© Copyright 2020 California Wok. All Rights Reserved</div>
            </Layout>
        </div>
    )
}